<base-site-layout [heading]="'Bedarfsmeldungen' | translate" headerIcon="fas fa-envelope-open-text">
    <base-site-layout-action>
        <div class="d-flex flex-column flex-md-row gap-2 w-100">
            <button
                data-cy="CREATE_PURCHASE_REQUISITION"
                class="btn btn-primary btn-block flex-grow-1"
                [routerLink]="'/' + View.CLIENT + '/rfq/demand/create'"
            >
                <em class="fas fa-plus me-2"></em>
                <span
                    [matBadge]="1"
                    matBadgePosition="above after"
                    matBadgeColor="accent"
                    [matBadgeHidden]="!unannouncedDemandExists"
                >
                    {{ 'Neuen Bedarf melden' | translate }}
                </span>
            </button>
            <ng-container *featureActive="EprocFeature.EPROC_AI">
                <button type="button" class="btn btn-primary btn-block flex-grow-1" (click)="openPdfUpload()">
                    <em class="fas fa-file-upload me-2"></em>
                    <span>{{ 'Bedarfsmeldung durch PDF-Upload erzeugen' | translate }}</span>
                </button>
            </ng-container>
        </div>
    </base-site-layout-action>
    @if (purchaseRequisitions && filter && pagination) {
        <div class="row py-2">
            <div class="col">
                <iim-pagination
                    [pagination]="pagination"
                    [translations]="paginationTranslations"
                    (paginationChanged)="getData()"
                >
                    <iim-table
                        [mobileThreshold]="1399"
                        [tableHeaders]="header"
                        [tableContent]="tableContent"
                        [filtersActive]="true"
                        [tableActions]="tableActions"
                        [tableInfo]="infoRow"
                        (onSort)="sorting.setDirection($event?.direction); filterChanged$.next()"
                        (filterClosed)="filterChanged$.next()"
                    >
                        <iim-table-filter-preview-entry
                            dataCyInput="FILTER_DISPLAY_NUMBER"
                            [label]="'Nummer' | translate"
                            [content]="filter.displayNumber"
                            (removed)="clearNumberFilter()"
                        ></iim-table-filter-preview-entry>
                        <iim-table-filter-preview-entry
                            dataCyInput="orderDateFilter"
                            [label]="'Erstellt' | translate"
                            [content]="filter.created | formatDateRange: ('ab' | translate) : ('bis' | translate)"
                            (removed)="filter.removeCreated(); filterChanged$.next()"
                        ></iim-table-filter-preview-entry>
                        <iim-table-filter-preview-entry
                            [label]="'Lieferant' | translate"
                            [content]="filter.supplierName"
                            (removed)="filter.removeSupplier(); filterChanged$.next()"
                        ></iim-table-filter-preview-entry>
                        <iim-table-filter-preview-entry
                            [label]="'Bedarfsträger' | translate"
                            [content]="filter.consumerName"
                            (removed)="filter.removeConsumer(); filterChanged$.next()"
                        ></iim-table-filter-preview-entry>
                        <iim-table-filter-preview-entry
                            [label]="'Abteilung' | translate"
                            [content]="filter.departmentName"
                            (removed)="filter.removeDepartment(); filterChanged$.next()"
                        ></iim-table-filter-preview-entry>
                        <iim-table-filter-preview-entry
                            [label]="'Inhalt' | translate"
                            [content]="filter.content"
                            (removed)="filter.content = ''; filterChanged$.next()"
                        ></iim-table-filter-preview-entry>
                        <ng-template #tableActions>
                            <!--
                                Number search of the list header, markup and interaction taken from the
                                reference list `order-list` (EPROC-11936). The label is visually hidden
                                and the placeholder carries it on screen: the toolbar puts the search
                                next to three filters that are labelled the same way, and a visible
                                label above a single one of them would break that row.
                            -->
                            <div class="col-md-auto col-sm-12 mb-1 mb-md-0 mb-lg-0 mb-xl-0 px-2">
                                <div class="input-group">
                                    <label for="purchaseRequisitionNumberSearch" class="visually-hidden">
                                        {{ 'Nummer' | translate }}
                                    </label>
                                    <span class="input-group-text">
                                        <em class="fas fa-search" aria-hidden="true"></em>
                                    </span>
                                    <input
                                        #numberSearchInput
                                        id="purchaseRequisitionNumberSearch"
                                        type="text"
                                        class="form-control"
                                        style="min-width: 220px"
                                        data-cy="PURCHASE_REQUISITION_NUMBER_SEARCH"
                                        [formControl]="numberSearchControl"
                                        [placeholder]="'Nummer' | translate"
                                    />
                                    @if (numberSearchControl.value) {
                                        <button
                                            type="button"
                                            class="input-group-text cursor-pointer"
                                            data-cy="PURCHASE_REQUISITION_NUMBER_SEARCH_RESET"
                                            [attr.aria-label]="'Suche zurücksetzen' | translate"
                                            (click)="clearNumberFilter(true)"
                                        >
                                            <em class="fas fa-trash" aria-hidden="true"></em>
                                        </button>
                                    }
                                </div>
                            </div>
                            <div class="col-md-auto col-sm-12 mb-1 mb-md-0 mb-lg-0 mb-xl-0 px-2">
                                <div class="input-group">
                                    <select
                                        data-cy="PURCHASE_REQUISITION_STATUS_FILTER"
                                        class="form-select"
                                        [(ngModel)]="filter.status"
                                        (ngModelChange)="filterChanged$.next()"
                                    >
                                        <option [ngValue]="undefined">{{ 'Alle' | translate }}</option>
                                        <option [ngValue]="Status.APPROVED">{{ 'freigegeben' | translate }}</option>
                                        <option [ngValue]="Status.REJECTED">{{ 'abgelehnt' | translate }}</option>
                                        <option [ngValue]="Status.WITHDRAWN">{{ 'zurückgezogen' | translate }}</option>
                                        <option [ngValue]="Status.PENDING">
                                            {{ 'freigabe ausstehend' | translate }}
                                        </option>
                                    </select>
                                    @if (filter.status !== undefined) {
                                        <span
                                            class="input-group-text cursor-pointer"
                                            (click)="filter.status = undefined; filterChanged$.next()"
                                        >
                                            <em class="fas fa-trash"></em>
                                        </span>
                                    }
                                </div>
                            </div>
                            <div class="col-md-auto col-sm-12 mb-1 mb-md-0 mb-lg-0 mb-xl-0 px-2">
                                <div class="input-group">
                                    <select
                                        data-cy="PURCHASE_REQUISITION_ORDER_STATUS_FILTER"
                                        class="form-select"
                                        [(ngModel)]="filter.orderStatus"
                                        (ngModelChange)="filterChanged$.next()"
                                    >
                                        <option [ngValue]="undefined">{{ 'Bestellstatus: Alle' | translate }}</option>
                                        <option [ngValue]="OrderStatus.NOT_ORDERED">
                                            {{ 'Nicht bestellt' | translate }}
                                        </option>
                                        <option [ngValue]="OrderStatus.PARTIALLY_ORDERED">
                                            {{ 'Teilweise bestellt' | translate }}
                                        </option>
                                        <option [ngValue]="OrderStatus.FULLY_ORDERED">
                                            {{ 'Vollständig bestellt' | translate }}
                                        </option>
                                    </select>
                                    @if (filter.orderStatus !== undefined) {
                                        <span
                                            class="input-group-text cursor-pointer"
                                            (click)="filter.orderStatus = undefined; filterChanged$.next()"
                                        >
                                            <em class="fas fa-trash"></em>
                                        </span>
                                    }
                                </div>
                            </div>
                            <div class="col-md-auto col-sm-12 mb-1 mb-md-0 mb-lg-0 mb-xl-0 px-2">
                                <div class="input-group">
                                    <select
                                        data-cy="PURCHASE_REQUISITION_DELIVERY_STATUS_FILTER"
                                        class="form-select"
                                        [(ngModel)]="filter.deliveryStatus"
                                        (ngModelChange)="filterChanged$.next()"
                                    >
                                        <option [ngValue]="undefined">{{ 'Lieferstatus: Alle' | translate }}</option>
                                        <option [ngValue]="DeliveryStatus.NOT_DELIVERED">
                                            {{ 'Nicht geliefert' | translate }}
                                        </option>
                                        <option [ngValue]="DeliveryStatus.PARTIALLY_DELIVERED">
                                            {{ 'Teilweise geliefert' | translate }}
                                        </option>
                                        <option [ngValue]="DeliveryStatus.FULLY_DELIVERED">
                                            {{ 'Vollständig geliefert' | translate }}
                                        </option>
                                    </select>
                                    @if (filter.deliveryStatus !== undefined) {
                                        <span
                                            class="input-group-text cursor-pointer"
                                            (click)="filter.deliveryStatus = undefined; filterChanged$.next()"
                                        >
                                            <em class="fas fa-trash"></em>
                                        </span>
                                    }
                                </div>
                            </div>
                        </ng-template>
                        <ng-template #infoRow>
                            <iim-table-filter-text
                                #numberFilter
                                data-cy="PURCHASE_REQUISITION_NUMBER_FILTER"
                                [label]="'Nummer' | translate"
                                [placeholder]="'Nummer' | translate"
                                [(value)]="filter.displayNumber"
                                (keydown.enter)="submitFilterPanelSearch(FilterKey.DISPLAY_NUMBER, numberFilter.value)"
                            ></iim-table-filter-text>
                            <iim-table-filter-date-range
                                [label]="'Datum' | translate"
                                [placeholderFrom]="'Datum' | translate"
                                [placeholderTo]="'Datum' | translate"
                                [fromLabel]="'Von' | translate"
                                [toLabel]="'Bis' | translate"
                                [(value)]="filter.created"
                            ></iim-table-filter-date-range>
                            @if (suppliers) {
                                <iim-table-filter-typeahead
                                    [label]="'Lieferant' | translate"
                                    [fullWidth]="true"
                                    [placeholder]="'Lieferanten' | translate"
                                    [value]="filter.supplier"
                                    (valueChange)="filter.setSupplier($event)"
                                    [options]="suppliers"
                                    displayOptionKey="name"
                                    [optionTemplate]="supplierOptionsTemplate"
                                ></iim-table-filter-typeahead>
                            }
                            <ng-template #supplierOptionsTemplate let-option="option">
                                {{ option.name }}
                            </ng-template>
                            @if (clients) {
                                <iim-table-filter-typeahead
                                    [label]="'Bedarfsträger' | translate"
                                    [fullWidth]="true"
                                    [placeholder]="'Bedarfsträger' | translate"
                                    [value]="filter.consumer"
                                    (valueChange)="filter.setConsumer($event)"
                                    [options]="clients"
                                    displayOptionKey="fullName"
                                    [optionTemplate]="consumerOptionsTemplate"
                                ></iim-table-filter-typeahead>
                            }
                            <ng-template #consumerOptionsTemplate let-option="option">
                                {{ option.fullName }}
                            </ng-template>
                            @if (departments && (departments.length > 1 || filter.department)) {
                                <iim-table-filter-typeahead
                                    [label]="'Abteilung' | translate"
                                    [fullWidth]="true"
                                    [placeholder]="'Abteilung' | translate"
                                    [value]="filter.department"
                                    (valueChange)="filter.setDepartment($event)"
                                    [options]="departments"
                                    displayOptionKey="name"
                                    [optionTemplate]="departmentOptionsTemplate"
                                ></iim-table-filter-typeahead>
                            }
                            <ng-template #departmentOptionsTemplate let-option="option">
                                {{ option.name }}
                            </ng-template>
                            <iim-table-filter-text
                                #contentFilter
                                data-cy="PURCHASE_REQUISITION_CONTENT_FILTER"
                                [label]="'Inhalt' | translate"
                                [placeholder]="'Inhalt' | translate"
                                [(value)]="filter.content"
                                (keydown.enter)="submitFilterPanelSearch(FilterKey.CONTENT, contentFilter.value)"
                            ></iim-table-filter-text>
                        </ng-template>
                        <ng-template #header>
                            <iim-table-header-column name="NUMBER" xlClass="col-xl-1">
                                {{ 'Nummer' | translate }}
                            </iim-table-header-column>
                            <iim-table-header-column name="CREATION" sortingHeaderName="CREATED" xlClass="col-xl-2">
                                {{ 'Datum' | translate }}
                            </iim-table-header-column>
                            <iim-table-header-column name="CONSUMER" xlClass="col-xl-2">
                                {{ 'Bedarfsträger' | translate }}
                            </iim-table-header-column>
                            <iim-table-header-column name="SUPPLIERS" xlClass="col-xl-3">
                                {{ 'Lieferanten' | translate }}
                            </iim-table-header-column>
                            <iim-table-header-column [alignRight]="true" name="PRICE" xlClass="col-xl-1">
                                {{ 'Gesamtpreis' | translate }}
                            </iim-table-header-column>
                            <iim-table-header-column name="STATUS" xlClass="col-xl-2">
                                {{ 'Status' | translate }}
                            </iim-table-header-column>
                            <iim-table-header-column
                                name="ACTION"
                                [alignRight]="true"
                                xlClass="col-xl-1"
                            ></iim-table-header-column>
                        </ng-template>
                        <ng-template #tableContent>
                            @for (purchaseRequisition of purchaseRequisitions; track purchaseRequisition) {
                                <iim-table-row>
                                    <ng-template iimTableRowExpandable>
                                        <purchase-requisition-item-preview
                                            [preview]="purchaseRequisition"
                                            [rfqLinkAllowed]="rfqLinkAllowed"
                                            [orderLinkAllowed]="orderLinkAllowed"
                                        ></purchase-requisition-item-preview>
                                    </ng-template>
                                    <iim-table-column name="NUMBER" xlClass="col-xl-1">
                                        <span copyToClipboard data-cy="PURCHASE_REQUISITION_NUMBER">
                                            {{ purchaseRequisition.displayNumber }}
                                        </span>
                                    </iim-table-column>
                                    <iim-table-column name="CREATION" xlClass="col-xl-2">
                                        {{ purchaseRequisition.created }}
                                    </iim-table-column>
                                    <iim-table-column name="CONSUMER" xlClass="col-xl-2">
                                        {{ purchaseRequisition.demand.consumer | person }}
                                    </iim-table-column>
                                    <iim-table-column name="SUPPLIERS" xlClass="col-xl-3">
                                        <purchase-requisition-supplier-preview
                                            [suppliers]="purchaseRequisition.demand.suppliers"
                                        ></purchase-requisition-supplier-preview>
                                    </iim-table-column>
                                    <iim-table-column [alignRight]="true" name="PRICE" xlClass="col-xl-1">
                                        @for (price of purchaseRequisition.demand.price; track price) {
                                            <div class="row mx-auto">
                                                <div class="col">
                                                    <display-currency
                                                        [value]="price.netPrice"
                                                        [currencyCode]="price.currency"
                                                    />
                                                </div>
                                            </div>
                                        }
                                    </iim-table-column>
                                    <iim-table-column name="STATUS" xlClass="col-xl-2">
                                        <div class="d-flex flex-column gap-1 align-items-start">
                                            <purchase-requisition-status-display
                                                [attr.data-cy]="'APPROVED_STATUS_' + purchaseRequisition.displayNumber"
                                                [status]="purchaseRequisition.status.value"
                                            ></purchase-requisition-status-display>
                                            <purchase-requisition-order-status-display
                                                [attr.data-cy]="'ORDER_STATUS_' + purchaseRequisition.displayNumber"
                                                [status]="purchaseRequisition.orderStatus"
                                            ></purchase-requisition-order-status-display>
                                            <purchase-requisition-delivery-status-display
                                                [attr.data-cy]="'DELIVERY_STATUS_' + purchaseRequisition.displayNumber"
                                                [status]="purchaseRequisition.deliveryStatus"
                                            ></purchase-requisition-delivery-status-display>
                                        </div>
                                    </iim-table-column>
                                    <iim-table-column name="ACTION" xlClass="col-xl-1">
                                        <div class="row justify-content-end align-items-center full-height margin-auto">
                                            <div class="col-auto padding-0">
                                                <button
                                                    data-cy="show-order"
                                                    class="btn btn-primary"
                                                    [routerLink]="
                                                        '/' +
                                                        View.CLIENT +
                                                        '/rfq/purchase-requisition/' +
                                                        purchaseRequisition.id +
                                                        '/detail'
                                                    "
                                                >
                                                    <em class="fas fa-arrow-right pe-2"></em>
                                                    {{ 'zeigen' | translate }}
                                                </button>
                                            </div>
                                        </div>
                                    </iim-table-column>
                                </iim-table-row>
                            }
                        </ng-template>
                    </iim-table>
                </iim-pagination>
            </div>
        </div>
    }
    @if (purchaseRequisitions && purchaseRequisitions.length === 0) {
        <div class="row justify-content-center margin-top-20">
            <div class="col-6 alert alert-info">
                {{ 'Es wurden keine Bedarfsmeldungen gefunden.' | translate }}
            </div>
        </div>
    }
</base-site-layout>
